var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.402 4.09775C14.2478 3.94359 14.0583 3.8665 13.8333 3.8665H7.83325L6.63325 2.6665H2.63325C2.40825 2.6665 2.21867 2.74359 2.0645 2.89775C1.91034 3.05192 1.83325 3.2415 1.83325 3.4665V11.8665C1.83325 12.0915 1.91034 12.2811 2.0645 12.4353C2.21867 12.5894 2.40825 12.6665 2.63325 12.6665H13.8333C14.0583 12.6665 14.2478 12.5894 14.402 12.4353C14.5562 12.2811 14.6332 12.0915 14.6332 11.8665V4.6665C14.6332 4.4415 14.5562 4.25192 14.402 4.09775ZM6.21904 3.6665H2.83325V11.6665H13.6332V4.8665H7.41904L6.21904 3.6665Z",
    fill: "#0D074B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder1);
export default __webpack_public_path__ + "static/media/folder_1.28d15ea24e3417019b2f9ac2e784b8d2.svg";
export { ForwardRef as ReactComponent };